/* eslint-disable import/no-default-export */
export default {
  actions: {
    label: 'Action',
    disabledActionLabel: 'You cannot perform actions in an unfollowed position.',
    disabledActionLabelDeactivated: 'This candidate has deactivated their AppyHere account.',
    disabledActionLabelNotLookingForWork: 'This candidate is not currently looking for work and cannot be contacted.',
    adHoc: {
      label: 'On-Demand Interview',
      confirmationModal: {
        header: 'Set Up On-Demand Interview',
        title: 'Title',
        interviewType: {
          video: 'Video',
          inPerson: 'In person',
          phone: 'Phone',
        },
        to: 'to',
        startTime: 'Start Time',
        endTime: 'End time',
        addCollaborators: 'Invite Co-interviewers',
        add: 'Add',
        timeZonePlaceholder: 'Select Timezone',
        emailPlaceholder: 'Enter email address',
        cancelButton: 'Cancel',
        sendButton: 'Send Invite',
        titleRequired: 'You must enter a title',
        appointmentTypesRequired: 'You must select at least 1 interview type',
        startDateRequired: 'You must select a date',
        timeZoneRequired: 'You must select a time zone',
        startTimeRequired: 'You must enter a start time',
        endTimeRequired: 'You must enter an end time',
        endTimeGreater: 'The end time must be later than the start time',
        invalidEmail: 'The email address must be valid',
        interviewExist: 'Candidate has already active interview',
        interviewLocationRequired: 'You must enter an interview location',
        interviewLocation: 'Interview Location',
      },
    },
    meet: {
      interviewLabel: 'Interview',
      label: 'Interview Request',
      confirmationModal: {
        header: '{{duration}} min. {{type, upperFirst}} Interview Request',
        body: 'The candidate will see a selection of available time slots for an interview.',
        cancelButton: 'Cancel',
        sendButton: 'Send',
      },
      notificationModal: {
        header: 'No Recruiter Interview Availability',
        body:
          'To invite a candidate for an interview at least one recruiter in your organization needs availability in the AppyHere calendar.',
        cancelButton: 'Cancel',
        createButton: 'Add Availability',
        addAvailabilityThroughMobileApp: 'Use the mobile app to add availability to your calendar.',
      },
      watchedRecruiterModal: {
        header: 'Watched Recruiter',
        body: 'Your availability will not be considered for positions you are watching.',
      },
    },
    dismiss: {
      label: 'Dismiss',
      confirmationModal: {
        header: 'Dismiss This Candidate?',
        body: 'The candidate will not be considered for this position.',
        dismissalReasonEnabledBody:
          'This candidate will not be considered for this position. Please select a reason for their dismissal:',
        cancelButton: 'Cancel',
        sendButton: 'Confirm',
        others: 'Other reason(s)',
        errorMsg: 'You must select dismissal reason.',
        reasonForDismissal: 'Specify the reason(s) for dismissal',
      },
    },
    undismiss: {
      label: 'Reverse the dismissal for this candidate.',
      confirmationModal: {
        header: `Reverse This Candidate's Dismissal`,
        body: 'The candidate will no longer be considered dismissed, and will be returned to the active candidate list.',
        notSuitableText:
          'This candidate was previously marked as <bold>not suitable for this position</bold>. Performing this action will allow the candidate to be considered for this position and others of the same type.',
        cancelButton: 'Cancel',
        sendButton: 'Confirm',
      },
    },
    unDismissButton: 'Undo Dismissal',
    backgroundCheck: {
      label: 'Background Check',
      confirmationModal: {
        header: 'Contact us to add background checks!',
        body: 'For more information on how to add background checks to your account, you can email us directly.',
        sendButton: 'Ok',
      },
    },
    hire: {
      startDate: 'Start date',
      modalMessage: 'Note',
      hireDetailsDesc1: 'The candidate was hired.',
      dateOfJoining: 'First Date of Employment',
      hireOrReject: 'Hire / Reject',
      hire: 'Hire',
      unhire: 'Unhire',
      offerMade: 'Make an Offer',
      reoffer: 'Send New Offer',
      label: 'Hire',
      sendMessageToCandidates: 'Send offer to the candidate',
      sendMessageToCandidatesToolTip:
        'Checking this box will send the offer message to the candidate, allowing the candidate to update their earliest available date if needed.',
      autoDismissCandidates: 'Automatically dismiss the candidate if offer is rejected.',
      autoDismissCandidatesToolTip: 'Checking this box will dismiss the candidate if they reject the offer.',
      confirmationModal: {
        salary: 'Salary',
        hourly: 'Hourly',
        annually: 'Annual',
        annual: 'Annually',
        custom: 'Custom',
        salaryValue: 'Salary Value',
        customUnit: 'Custom Unit',
        header: 'Enter salary details about the offer',
        body: 'Add Details',
        cancelButton: 'Cancel',
        sendButton: 'Submit',
        saveButton: 'Save',
        text1: `Initial Proposed Salary is `,
        text2: `which is to be paid`,
        candidateHiringForm: 'Candidate Hiring Form',
        selectHireFormType: 'Select Hire Form Type',
        hireFormType: 'Hire Form Type',
        contractStartDate: `Candidate’s earliest availability`,
        contractEndDate: `Contract End Date`,
        contractDetailsWording: `Terms`,
        contractDetailsWordingTooltip: `These terms will be included on the form sent to the candidate.`,
        contractWordingHintMessage: `As the candidate is using the french language in the app.`,
        contractTerms: ``,
        contractDetailsWordingPlaceholder: `Enter contract description`,
        candidateStatus: `Candidate's Status`,
        partTime: 'Part-time',
        fullTime: 'Full-time',
        storeNumber: 'Store Number',
        unitRequired: 'Unit is required',
        valueRequired: 'Value is required',
        noteRequired: 'Note is required',
        positionNameRequired: 'Position Name is required',
        businessNameRequired: 'Business Name is required',
        candidateStatusRequired: `Candidates status is required`,
        contractStartDateRequired: 'Earliest start date is required',
        contractEndDateRequired: 'Contract end date is required',
        contractDetailsWordingRequired: 'Contract details wording is required',
        startDateRequired: 'Earliest start date is required',
        storeNumberRequired: 'Store number is required',
        formTypeRequired: 'Form type is required',
        startNewHire: 'New hire',
        startWorkPermit: 'New hire for candidate with work permit',
        startSeasonalContractor: 'New hire for seasonal candidate',
        submit: 'Submit',
        workPermitEndDate: 'Work Permit End Date',
        country: 'Country',
        partTimeHoursPerWeek: 'Hours/Week',
        confirmBtn: 'Confirm',
        employmentStartDateRequired: 'You must select an employment start date.',
        salaryRangeError: 'Salary must be between {{minSalary}} and {{maxSalary}}.',
        fixedSalaryRangeError: 'Salary must be {{minSalary}} or empty',
        positionTypeRequired: 'Position type is required for Australian positions.',
        invalidPositionType: 'Invalid position type value.',
        positionTypeLabel: 'Employment Type',
      },
      messageAfterHiringModal: {
        headerText: 'AppyHere will send notification to seekers informing that they are hired.',
        modalText: 'Candidates will be inactive in this platform and hence will be unavailable for other jobs.',
        dismissText: 'Never see this message again',
        buttonText: 'Ok',
      },
      rejectModal: {
        unhireCandidate: 'Unhire Candidate',
        reasonForChange: 'Write a reason for change',
        header: 'Hire Candidate',
        body: 'Has the candidate been hired?',
        hired: 'Start Hiring',
        rejected: 'Offer Rejected',
        seenToCandidatePlaceholder: 'Information entered here will not been seen by candidate',
        placeholder: 'Add Your Feedback',
        terminationType: 'Type of Termination',
        terminationTypePlaceholder: 'Select Termination Type',
        terminationReason: 'Termination Reason',
        terminationReasonPlaceholder: 'Select Termination Reason',
        terminationTypeVoluntary: 'Voluntary',
        terminationTypeInvoluntary: 'Involuntary',
        terminationReasonEndOfContract: 'End of Contract',
        terminationReasonOthers: 'Other',
        additionalNote: 'Additional Note',
        terminationNoteplaceholder: 'Do you want to note anything else about this termination?',
        notEligibleForRehire: 'Not Eligible For Rehire',
      },
      actionsAfterUnhire: {
        removeForever: 'Remove Forever',
        hireInFuture: 'I may want to hire this candidate in the future',
        hireHimAgain: 'Might you hire this candidate again?',
      },
      employmentStartDate: 'Employment Start Date',
      hrFromBtn: 'Hire Form',
      approveHrFrom: 'Approve',
      rejectHrFrom: 'Reject',
      resubmitHrFrom: 'Resubmit',
    },
    soon: 'soon',
    i9Check: {
      label: 'I-9 Request',
      modal: {
        title: 'Request I-9 Form',
        submittedDate: 'Last Submitted Date',
        targetDate: 'Target Hire Date',
        selectDate: 'Select Date',
        body: 'The I-9 form is used to verify the candidate’s identity and work authorization.',
        successMessage: 'I-9 form has been requested.',
        error422Toast: 'This candidate has already received an I-9 form request',
        error500Toast: 'I-9 requests have not been configured for this account.',
        errorDefaultToast: 'There was an error requesting the I-9 form.',
        submitBtn: 'Submit',
      },
    },
    questionReviewModal: {
      title: 'Review Question Responses',
    },
    unblock: {
      unblockButton: 'Unblock',
      modalHeader: 'Restore Applicant',
      modalBody: `This will remove the current restrictions on this profile. The individual will be able to view and submit applications for open job positions again. Are you sure you want to confirm?`,
      unblockSuccess: 'This candidate has been successfully unblocked.',
      unblockError: 'This candidate could not be unblocked due to an error. Please try again later.',
    },
  },
  candidateLocked: 'Message from candidate. Unlock it in the mobile app.',
  interviewRating: {
    title: 'Candidate Assessment',
    subTitle: `How did the interview with the candidate go?`,
    lowReason: 'Select a reason for the low rating:',
    commentPlaceholder: 'Leave a comment',
    successful: 'Rating successful',
    feedback: 'Candidate Assessment',
    unsuccessful: 'Candidate must have an appointment to be able to send an assessment',
    dateAndTimeOFInterview: 'Date & Time of Interview',
    interviewType: 'Interview Type',
    feedbackDetail: 'How did the interview with the candidate go? ',
    recruitersFeedback: 'Comments ',
    rateCandidate: 'Evaluate Candidate',
  },
  chatInput: {
    deactivatedUserLabel: 'The candidate must have had an interview before they can be assessed.',
  },
  headerWhenRequisitionEnabled: 'Offer Made',
  offerMadewarning: {
    title: 'Candidate Hires and Offers',
    subtitle: 'This candidate has already been hired on a position, or has received other offers.',
    continueAnyWay: 'Send anyway',
    position: 'Position',
    recruiter: 'Recruiter',
    date: 'Offer Date',
    offerStatus: 'Offer Status',
    currentStatus: 'Candidate Status',
    offerHistory: 'Offer & Hire History',
    hireThroughAPI: 'Virtual Recruiter',
  },
  upcommingInterviewBanner: {
    videoInterview: 'Video Interview',
    inPersonInterview: 'In-Person Interview',
    phoneInterview: 'Phone Interview',
    buttonLabel: 'Start Video Interview',
    pastInterviewDate: 'Started at {{date}}',
    upcomingInterviewDate: 'Starting on {{date}} at {{time}}',
    bannerOngoingInterview: 'Ongoing {{interviewType}} by',
    bannerUpcomingInterview: 'Upcoming {{interviewType}} by',
    yourInterview: 'You',
  },
};
